import { OrganizationProjects, OrganizationUsers, ProjectUsers } from '@models';

export function normalizeUuid(value: string | null | undefined): string {
  const input = `${value ?? ''}`.trim();
  if (!input) return '';
  const compact = input.replace(/-/g, '').toLowerCase();
  if (!/^[0-9a-f]{32}$/.test(compact)) {
    return input;
  }
  return `${compact.slice(0, 8)}-${compact.slice(8, 12)}-${compact.slice(12, 16)}-${compact.slice(16, 20)}-${compact.slice(20)}`;
}

export function organizationUserKey(item: Partial<OrganizationUsers> | null | undefined): string {
  if (!item) return '';
  const organizationId = normalizeUuid(item.organizationId ?? '');
  const userId = normalizeUuid(item.userId ?? '');
  if (!organizationId || !userId) return '';
  return `${organizationId}:${userId}`;
}

export function projectUserKey(item: Partial<ProjectUsers> | null | undefined): string {
  if (!item) return '';
  const projectId = normalizeUuid(item.projectId ?? '');
  const userId = normalizeUuid(item.userId ?? '');
  if (!projectId || !userId) return '';
  return `${projectId}:${userId}`;
}

export function organizationProjectKey(
  item: Partial<OrganizationProjects> | null | undefined
): string {
  if (!item) return '';
  const organizationId = normalizeUuid(item.organizationId ?? '');
  const projectId = normalizeUuid(item.projectId ?? '');
  if (!organizationId || !projectId) return '';
  return `${organizationId}:${projectId}`;
}
